import { agentStatusPalette } from "@callcenter/design-system"

export const statusColors: Record<string, string> = {
  online: agentStatusPalette.online,
  in_call: agentStatusPalette.inCall,
  offline: agentStatusPalette.offline,
  away: agentStatusPalette.away,
  ringing: agentStatusPalette.ringing,
  postcall: agentStatusPalette.postcall,
  campaign_postcall: agentStatusPalette.postcall,
  hold: agentStatusPalette.hold,
  transfer_from_ringing: agentStatusPalette.transferFromRinging,
  transfer_from_talk: agentStatusPalette.transferFromTalk,
  transfer_to_ringing: agentStatusPalette.transferToRinging,
  transfer_to_talk: agentStatusPalette.transferToTalk,
  "int-out-ringing": agentStatusPalette.intOutRinging,
  "int-out-talk": agentStatusPalette.intOutTalk,
  "int-in-ringing": agentStatusPalette.intInRinging,
  "int-in-talk": agentStatusPalette.intInTalk,
  "ext-ringing": agentStatusPalette.extRinging,
  "ext-talk": agentStatusPalette.extTalk,
  dialing: agentStatusPalette.dialing,
  outbound: agentStatusPalette.outbound,
  dialer: agentStatusPalette.dialer,
  dialer_waiting: agentStatusPalette.dialer,
  dialer_talk: agentStatusPalette.dialerTalk,
  waiting: agentStatusPalette.dialing
}

export const getStatusColor = (status: string): string => statusColors[status] || statusColors.away
